import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import theme from '../../../common/theme';
import { styles } from './ScreenRow.styles';
import Icon from '../../Icon/Icon';

interface Props {
  displayName: string;
  width: number;
  height: number;
  position?: { x: number; y: number };
  isPrimary: boolean;
  isCurrent: boolean;
  isStarred: boolean;
  starredBadgeLabel: string;
  isDisabled?: boolean;
  onSelect: () => void;
}

const ScreenRow: React.FC<Props> = ({
  displayName,
  width,
  height,
  position,
  isPrimary,
  isCurrent,
  isStarred,
  starredBadgeLabel,
  isDisabled = false,
  onSelect,
}) => {
  const badges: string[] = [];
  if (isCurrent) badges.push('Current');
  if (isPrimary) badges.push('Primary');
  if (isStarred) badges.push(starredBadgeLabel);

  const details = position
    ? `${width} × ${height} @ ${position.x},${position.y}`
    : `${width} × ${height}`;

  return (
    <TouchableOpacity
      disabled={isDisabled}
      style={styles.container}
      onPress={onSelect}
    >
      <Icon
        size={24}
        name={isCurrent ? 'check-circle' : 'circle'}
        color={theme.palette[isCurrent ? 'green' : 'mono500']}
      />
      <View style={styles.text}>
        <Text style={styles.title}>{displayName}</Text>
        <Text style={styles.subtitle}>{details}</Text>
      </View>
      {badges.length > 0 && (
        <View style={styles.badges}>
          {badges.map((badge, i) => (
            <View key={i} style={styles.badge}>
              <Text style={styles.badgeText}>{badge}</Text>
            </View>
          ))}
        </View>
      )}
    </TouchableOpacity>
  );
};

export default ScreenRow;
